import { createContext, useContext } from 'react'
import type { ValidationWarning } from '@/services/core/validationWarnings'

/**
 * The server's validation warnings on the list row a cell sits in, so the
 * row's name cell can flag them. `DataTable` provides it for every row.
 */
export const RowWarningsContext = createContext<ValidationWarning[]>([])

export function useRowWarnings() {
  return useContext(RowWarningsContext)
}
